import { useNavigate } from 'react-router-dom'

import { Box, Icon, Section, Text } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'

import { useGetIncidenceSettings } from 'modules/bookkeepers/hooks/useGetIncidenceSettings'
import { FACTORIAL_APP, toIncidencesSettings } from 'modules/bookkeepers/lib/amplitudeData'
import { useInhousePayroll } from 'modules/payroll_bundle/hooks/useInhousePayroll'

const Content = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const {
    company: { id: companyId, name: companyName },
  } = useCurrentSession()
  const { hasInhousePayroll } = useInhousePayroll()
  const { trackedEventsCount } = useGetIncidenceSettings(companyId, false)
  const hasDevCompensations = hasFeature('dev_compensations')

  const navigateToManageIncidences = (source: string) => {
    track(trackingEvents.bookkeeper.incidences.goToIncidencesSettings, {
      application: FACTORIAL_APP,
      company_name: companyName,
      has_professionals: hasFeature('factorial_professionals'),
      has_in_house_payroll: hasInhousePayroll,
      source: source,
    })

    return hasDevCompensations
      ? navigate(navigation.settings.compensations.employeeUpdates.fullPath())
      : navigate(navigation.settings.payroll_bundle.incidences.fullPath())
  }

  return (
    <Box
      cursor="pointer"
      onClick={() => navigateToManageIncidences(toIncidencesSettings.fromPayrollSettings)}
      border={{
        all: {
          color: 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
      borderRadius={{
        all: 'abs016',
      }}
      gap="s8"
      flexDirection="row"
      alignItems="center"
      justifyContent="spaceBetween"
      padding="s16"
    >
      <Box gap="s4">
        <Text.Normal color="grey1000" weight="medium">
          {i18n.t('app_store_v2.apps.payroll_bundle.settings.employee_updates.title')}
        </Text.Normal>
        <Text.Normal color="grey800" weight="normal" size="200">
          {i18n.t('app_store_v2.apps.payroll_bundle.settings.incidences.tracked_events', {
            events_count: trackedEventsCount,
          })}
        </Text.Normal>
      </Box>
      <Box
        padding="s2"
        border={{
          all: {
            color: 'grey400',
            width: 's1',
            style: 'solid',
          },
        }}
        borderRadius={{
          all: 'rel500',
        }}
      >
        <Icon.Medium icon="arrow-right" />
      </Box>
    </Box>
  )
}

const EmployeeUpdates = () => (
  <Section
    title={i18n.t('app_store_v2.apps.payroll_bundle.settings.employee_updates.section_title')}
    illustration="bell"
    description={i18n.t(
      'app_store_v2.apps.payroll_bundle.settings.employee_updates.section_description'
    )}
  >
    <Content />
  </Section>
)

export default EmployeeUpdates
